<div class="sidenav">
  <div class="sidenav__header">
    <img src="assets/images/Logo-MiEsSalud-ColorHorizontal.png" alt="Essalud" class="sidenav__img2" />
    <div class="sidenav__block"></div>
  </div>
  <div class="sidenav__body">
    <div class="header-avatar">
      <p class="ltitle">Bienvenido</p>
      <img *ngIf="!dataPersona.imagenPerfilBase64" src="assets/images/avatar.png" alt="Essalud" class="sidenav__img" />
      <img *ngIf="dataPersona.imagenPerfilBase64" [src]="'data:image/png;base64,' + dataPersona.imagenPerfilBase64" alt="Essalud" class="sidenav__img imgBorde" />
        <b>{{ dataPersona.nombres | titlecase }}</b><br>
        <h5 class="brand__description">{{ dataPersona.correo }}</h5>
        <div class="optSidenav">
          <mat-icon #tooltip="matTooltip" matTooltip="Cambiar contraseña" class="cursor" (click)="cambiar_contra()">lock</mat-icon>
          <mat-icon #tooltip="matTooltip" matTooltip="Editar Perfil" class="cursor" (click)="showEditPerfil()">edit</mat-icon>
        </div>
        <!-- <h4>Gerencia: {{ gerencia }}</h4> -->
    </div>  
    <mat-nav-list>
      <ng-container>
        <div *ngFor="let item of menuItemList">
          <mat-list-item *ngIf="item.type == undefined"
            routerLinkActive="active"
            [routerLink]="['/' + item.path]"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <mat-icon *ngIf ="!item.svg" mat-list-icon>{{ item.icon }}</mat-icon>
            <mat-icon *ngIf ="item.svg" mat-list-icon svgIcon={{item.icon}} class="icon"></mat-icon>
            <span class="option" matLine>{{ item.label }} </span>
          </mat-list-item>
          <mat-list-item *ngIf="item.type == 2" class="listItemImage" (click)="open(item.label)">
            <mat-icon *ngIf ="!item.svg" mat-list-icon>{{ item.icon }}</mat-icon>
            <mat-icon *ngIf ="item.svg" mat-list-icon svgIcon={{item.icon}} class="icon iconPopUp"></mat-icon>
            <span class="option" matLine>{{ item.label }} </span>
          </mat-list-item>
          <mat-expansion-panel *ngIf="item.type == 3" [class.mat-elevation-z0]="true" class="subMenu">
            <mat-expansion-panel-header>
              <mat-icon *ngIf ="!item.svg" mat-list-icon>{{ item.icon }}</mat-icon>
              <mat-icon *ngIf ="item.svg" mat-list-icon svgIcon={{item.icon}} class="icon"></mat-icon>
              <span class="option" matLine>{{ item.label }} </span>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <ng-container *ngFor="let subItem of item.children">
              <mat-list-item *ngIf="subItem.roles.includes(user.idRol)" routerLinkActive="active" [routerLink]="['/' + subItem.path]" [routerLinkActiveOptions]="{ exact: true }">
                <mat-icon *ngIf ="!subItem.svg" mat-list-icon>{{ subItem.icon }}</mat-icon>
                <mat-icon *ngIf ="subItem.svg" mat-list-icon svgIcon={{subItem.icon}} class="icon"></mat-icon>
                <span class="option" matLine>{{ subItem.label }} </span>
              </mat-list-item></ng-container>
            </mat-nav-list>
          </mat-expansion-panel>
          <ng-container *ngIf="item.type == 4">
            <mat-list-item *ngIf="asignacionesInscripciones.length != 0" routerLinkActive="active" [routerLink]="['/' + item.path]" [routerLinkActiveOptions]="{ exact: true }">
              <mat-icon *ngIf ="!item.svg" mat-list-icon>{{ item.icon }}</mat-icon>
              <mat-icon *ngIf ="item.svg" mat-list-icon svgIcon={{item.icon}} class="icon iconPopUp"></mat-icon>
              <span class="option" matLine>{{ item.label }} </span>
            </mat-list-item>
          </ng-container>
        </div>
        <!-- <mat-list-item *ngIf="user.id == 291 || user.id == 12560" routerLinkActive="active" [routerLink]="['/administracion/renueva-proyectos']" [routerLinkActiveOptions]="{ exact: true }">
          <mat-icon mat-list-icon>library_books</mat-icon>
          <span class="option" matLine>Proyectos de Renueva EsSalud </span>
        </mat-list-item> -->
        <mat-list-item *ngIf="user.id == 11511" routerLinkActive="active" [routerLink]="['/administracion/encuestas']" [routerLinkActiveOptions]="{ exact: true }"><!---------------------AQUI----------------------->
          <mat-icon mat-list-icon>assignment</mat-icon>
          <span class="option" matLine>Encuestas Asignadas </span>
        </mat-list-item>
        <!-- modulo-gr -->
        <ng-container *ngIf="activarModuloGr">
          <mat-list-item *ngIf="votanteSegmento == segmentoJefe || votanteSegmento == evaluador || esMaestroGdr" routerLinkActive="active" [routerLink]="['/gestion-rendimiento']" [routerLinkActiveOptions]="{ exact: true }">
            <mat-icon mat-list-icon>description</mat-icon>
            <span class="option" matLine>Gestión del Rendimiento</span>
          </mat-list-item>
          <!-- OCULTAR GDR PARA EVALUADO - TEMPORALMENTE EN PRODUCCIÓN
          <mat-list-item *ngIf="votanteSegmento == segmentoTrabajador" routerLinkActive="active" [routerLink]="['/indicadores-trabajador']" [routerLinkActiveOptions]="{ exact: true }">
            <mat-icon mat-list-icon>description</mat-icon>
            <span class="option" matLine>Gestión del Rendimiento</span>
          </mat-list-item>
          -->
        </ng-container>

        <mat-list-item (click)='openPIGRH()'>
          <mat-icon mat-list-icon>open_in_new</mat-icon>
          <span class="option" matLine style="display: block; white-space: normal; line-height: 20px;">
            PIGRH - Plataforma Integral de Gestión del Recurso Humano
          </span>
        </mat-list-item>
        <mat-list-item routerLinkActive="active" [routerLink]="['/plazas']" [routerLinkActiveOptions]="{ exact: true }" *ngIf='tienePermisoModuloPlaza'>
          <mat-icon mat-list-icon>assignment</mat-icon>
          <span class="option" matLine>Plazas</span>
        </mat-list-item>
        <!-- <mat-list-item routerLinkActive="active" [routerLink]="['/materiales']" [routerLinkActiveOptions]="{ exact: true }" *ngIf="rol == 4">
          <mat-icon mat-list-icon>assignment</mat-icon>
          <span class="option" matLine>Materiales</span>
        </mat-list-item> -->
        
        <!-- <mat-list-item (click)='openPDP()'>
          <mat-icon mat-list-icon>school</mat-icon>
          <span class="option" matLine>PDP - Plan de Desarrollo de Personas</span>
        </mat-list-item> -->

        <!-- <mat-list-item (click)='openLinkCAFAE()'>
          <mat-icon mat-list-icon>link</mat-icon>
          <span class="option" matLine>Elecciones CAFAE Essalud 2024</span>
        </mat-list-item> -->

        <mat-list-item (click)='openLinkCAFAE2028()'>
          <mat-icon mat-list-icon>link</mat-icon>
          <span class="option" matLine>CAFAE - ELECCIONES 2026 - 2028</span>
        </mat-list-item>

        <!-- <mat-list-item (click)='openLinkSeguroVida()'>
          <mat-icon mat-list-icon svgIcon='health_and_safety'></mat-icon>
          <span class="option" matLine style="display: block; white-space: normal; line-height: 20px;">
            Afiliación Digital +Vida Seguro de Accidentes
          </span>
        </mat-list-item> -->

      </ng-container>
    </mat-nav-list>
  </div>
</div>